"use client";

import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import { useGeneralSettings } from "@/packages/context/GeneralSettingContext";

export default function FloatingWhatsApp() {
  const { settings } = useGeneralSettings();

  // Secondary phone number from General Settings (falling back to primary phone)
  const rawPhone = settings?.contact?.secondary_phone || settings?.contact?.phone || "";

  if (!rawPhone) return null;

  // Clean phone number (strip out spaces, dashes, brackets, plus signs)
  const cleanPhone = rawPhone.replace(/\D/g, "");

  if (!cleanPhone) return null;

  const whatsappUrl = `https://wa.me/${cleanPhone}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-20 right-4 sm:bottom-6 sm:right-6 z-50 group flex items-center justify-center p-3.5 bg-[#25D366] hover:bg-[#20ba59] text-white rounded-full shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-110 active:scale-95"
    >
      {/* Pulse Ring */}
      <span className="absolute -inset-1 rounded-full bg-[#25D366] opacity-35 animate-ping group-hover:opacity-0 pointer-events-none" />

      {/* WhatsApp Icon */}
      <FaWhatsapp className="w-7 h-7 relative z-10 text-white drop-shadow-xs" />

      {/* Hover Tooltip */}
      <span className="absolute right-full mr-3 px-3 py-1.5 bg-slate-900/90 text-white text-xs font-semibold rounded-lg shadow-md opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none">
        Chat on WhatsApp
      </span>
    </a>
  );
}
